import React, { lazy, Suspense } from 'react';
import ErrorBoundary from '@wix/da-shared-react/pkg/ErrorBoundary';
import retry from '@wix/da-shared-react/pkg/utils/webpack/chunkRetry';
import ModuleLoaderLazy from '../redux/ModuleLoaderLazy';
import AbsoluteHeightLayout from '@wix/da-ds/pkg/AbsoluteHeightLayout';
import variables from '@wix/da-ds/src/styles/variables.scss';
var siteHeaderHeight = parseInt(variables['site-header-height'], 10);
var FeedbackPage = lazy(function () {
    return retry(function () {
        return import(
        /* webpackChunkName: "notifications_shared" */
        './index');
    });
});
export var FeedbackPageLoadable = function (_a) {
    var loadingIndicator = _a.loadingIndicator;
    return (React.createElement(ErrorBoundary, { debugComponent: "FeedbackPageLoadable" },
        React.createElement(AbsoluteHeightLayout, { heightReduction: siteHeaderHeight },
            React.createElement(Suspense, { fallback: loadingIndicator || null },
                React.createElement(ModuleLoaderLazy, null),
                React.createElement(FeedbackPage, null)))));
};
FeedbackPageLoadable.displayName = 'FeedbackPageLoadable';
export default FeedbackPageLoadable;
//# sourceMappingURL=FeedbackPageLoadable.js.map